import FloorBlock from "../race/block/FloorBlock.jsx";
import Plant from "../life/Plant.jsx";
import Dumbbell from "../life/Dumbbell.jsx";
import Telegram from "../life/Telegram.jsx";
import LinkendIn from "../life/LinkendIn.jsx";
import Email from "../life/Email.jsx";
import PizzaFinish from "../life/PizzaFinish.jsx";

const Hobby = ({ position = [0, 0, 0] }) => {
  return (
    <group position={position}>
      <FloorBlock
        position={[-11.5, 0, -16.5]}
        scale={0.7}
        rotation={[0, Math.PI / 4, 0]}
      />
      <FloorBlock
        position={[-13.5, 0, -13.5]}
        scale={0.7}
        rotation={[0, Math.PI / 8, 0]}
      />
      <FloorBlock
        position={[-12.5, 0, -9.5]}
        scale={0.7}
        rotation={[0, Math.PI / 3, 0]}
      />
      <FloorBlock
        position={[-14.5, 0, -6.5]}
        scale={0.7}
        rotation={[0, Math.PI / 5, 0]}
      />
      <FloorBlock
        position={[-16.5, 0, -2.5]}
        scale={0.7}
        rotation={[0, Math.PI / 7, 0]}
      />
      <FloorBlock
        position={[-18.5, 0, 1.5]}
        scale={0.7}
        rotation={[0, Math.PI / 10, 0]}
      />
      <Plant position={[-22.5, 0, 3.5]} />

      <FloorBlock
        position={[-16.5, 0, 5.5]}
        scale={0.7}
        rotation={[0, Math.PI / 3, 0]}
      />
      <FloorBlock
        position={[-14.5, 0, 9.5]}
        scale={0.7}
        rotation={[0, Math.PI / 4, 0]}
      />
      <FloorBlock
        position={[-10.5, 0, 10.5]}
        scale={0.7}
        rotation={[0, 0, 0]}
      />
      <FloorBlock
        position={[-6.5, 0, 12.5]}
        scale={0.7}
        rotation={[0, Math.PI / 4, 0]}
      />
      <FloorBlock
        position={[-2.5, 0, 10.5]}
        scale={0.7}
        rotation={[0, Math.PI / 6, 0]}
      />
      <Dumbbell position={[-6.5, 0, 16.5]} />

      <FloorBlock
        position={[0.5, 0, 6.5]}
        scale={0.7}
        rotation={[0, Math.PI / 8, 0]}
      />
      <FloorBlock
        position={[4.5, 0, 3.5]}
        scale={0.7}
        rotation={[0, Math.PI / 3, 0]}
      />
      <FloorBlock
        position={[1.5, 0, -0.5]}
        scale={0.7}
        rotation={[0, Math.PI / 5, 0]}
      />
      <FloorBlock
        position={[-1.5, 0, -3.5]}
        scale={0.7}
        rotation={[0, Math.PI / 6, 0]}
      />
      <FloorBlock
        position={[-3.5, 0, -7.5]}
        scale={0.7}
        rotation={[0, Math.PI / 7, 0]}
      />
      <FloorBlock
        position={[-7.5, 0, -9.5]}
        scale={0.7}
        rotation={[0, Math.PI / 9, 0]}
      />
      <FloorBlock
        position={[-9.5, 0, -12.5]}
        scale={0.7}
        rotation={[0, Math.PI / 3, 0]}
      />
      <Telegram position={[10.5, 0, 1.5]} />
      <LinkendIn position={[18.5, 0, 1.5]} />
      <Email position={[26.5, 0, 1.5]} />
      <PizzaFinish
        position={[-7.5, 0, 1.5]}
        pizzaPosition={[0, 1, 0]}
        boardPosition={[0, 0, 0]}
        pizzaScale={2.5}
        boardScale={2.5}
        pizzaRotationSpeed={0.2}
      />
    </group>
  );
};

export default Hobby;
